import { combineReducers } from 'redux';
import signUp from './reducers/signUpReducer';
import editProfile from './reducers/editProfileReducer';
import location from './reducers/locationReducer';
import notificationCenter from './reducers/notificationCenterReducers';
import currentUser from './reducers/currentUserReducer';
import additionalInformation from './reducers/additionalInformationReducer';
import groupMembership from './reducers/groupMembershipReducer';
import subscription from './reducers/subscriptionReducer';
import helpAndAnswer from './reducers/helpAndAnswerReducer';

export default combineReducers({
  signUp,
  location,
  editProfile,
  notificationCenter,
  currentUser,
  additionalInformation,
  groupMembership,
  subscription,
  helpAndAnswer,
});
